import React from 'react'
import PropTypes from 'prop-types'

import JudgeBox from './JudgeBox'

function JudgesContainer({ judges }) {
  return (
    <div className="row judges-container">
      {judges.map((judge) => {
        return (
          <JudgeBox
            key={judge.slug}
            judge={judge}
            imgPath={require(`images/competitions/digital_art/judges/${judge.slug}.png`)}
          />
        )
      })}
    </div>
  )
}

JudgesContainer.propTypes = {
  judges: PropTypes.array.isRequired,
}

export default JudgesContainer
